import { ActionExtended } from "../../../_common/interfaces/ActionExtended";
import { ACTIONS } from "../../../_config";

export interface GlobalReducer {
  gameDetails: any;
  seo_list: any;
  referrer_url: any;
  languages: any[];
  workplaces: any[];
  jobPostTypes: any[];
  skills: any[];
  countriesNew: any[];
  citiesNew: any[];
  currencies: any[];
  salaryRanges: any[];
  functionalAreas: any[];
  educationLevels: any[];
  jobTitleSuggestions: any[];
}

const initialState: GlobalReducer = {
  gameDetails: null,
  seo_list: null,
  referrer_url: null,
  languages: [],
  workplaces: [],
  jobPostTypes: [],
  skills: [],
  countriesNew: [],
  citiesNew: [],
  currencies: [],
  salaryRanges: [],
  functionalAreas: [],
  educationLevels: [],
  jobTitleSuggestions: [],
};

const globalsReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.COMMON.GAME_DETAILS:
      return {
        ...state,
        gameDetails: action.payload,
      };
    case ACTIONS.COMMON.SEO_LIST:
      return {
        ...state,
        seo_list: action.payload.data,
      };
    case ACTIONS.COMMON.REFFERER_URL:
      return {
        ...state,
        referrer_url: action.payload,
      };
    case ACTIONS.COMMON.LANGUAGES:
      return {
        ...state,
        languages: action.payload || [],
      };
    case ACTIONS.COMMON.WORK_PLACES:
      return {
        ...state,
        workplaces: action.payload || [],
      };
    case ACTIONS.COMMON.JOB_POST_TYPES:
      return {
        ...state,
        jobPostTypes: action.payload || [],
      };
    case ACTIONS.COMMON.SKILLS:
      return {
        ...state,
        skills: action.payload || [],
      };
    case ACTIONS.COMMON.COUNTRIES_NEW:
      return {
        ...state,
        countriesNew: action.payload || [],
      };
    case ACTIONS.COMMON.CITIES_NEW:
      return {
        ...state,
        citiesNew: action.payload || [],
      };
    case ACTIONS.COMMON.CURRENCIES:
      return {
        ...state,
        currencies: action.payload || [],
      };
    case ACTIONS.COMMON.SALARY_RANGES:
      return {
        ...state,
        salaryRanges: action.payload || [],
      };
    case ACTIONS.COMMON.FUNCTIONAL_AREAS:
      return {
        ...state,
        functionalAreas: action.payload || [],
      };
    case ACTIONS.COMMON.EDUCATION_LEVELS:
      return {
        ...state,
        educationLevels: action.payload || [],
      };
    case ACTIONS.COMMON.JOB_TITLE_SUGGESTIONS:
      return {
        ...state,
        jobTitleSuggestions: action.payload.suggestions || [],
      };
    default:
      return state;
  }
};

export default globalsReducer;
